module.exports = __webpack_public_path__ + "img/dashboard.91fcb5b6.svg";